import Simplemodal from '../../plugins/simplemodal.js';

const entryModal = new Simplemodal({
  trigger: "data-entry-modal-trigger",
  clickOutSideClose: true,
  backFixed: true
});
